// Affiliate Program JS
 
document.addEventListener("DOMContentLoaded", function () {
  const faqItems = document.querySelectorAll(".faqs-list dl");

  faqItems.forEach((item) => {
    const dt = item.querySelector("dt");
    const dd = item.querySelector("dd");

    // Initially hide all dd
    dd.style.display = "none";

    dt.style.cursor = "pointer";

    dt.addEventListener("click", () => {
      faqItems.forEach((otherItem) => {
        const otherDt = otherItem.querySelector("dt");
        const otherDd = otherItem.querySelector("dd");

        // Close all other dd elements
        if (otherItem !== item) {
          otherDd.style.display = "none";
          otherDt.classList.remove("active");
        }
      });

      // Toggle selected dd and dt
      const isOpen = dd.style.display === "block";
      dd.style.display = isOpen ? "none" : "block";
      dt.classList.toggle("active", !isOpen);
    });
  });
});
 



// Switch Color Option
 

// function updateSwatchLabelColors() {
//   document.querySelectorAll('.swatch-input__label').forEach(label => {
//     const swatch = label.querySelector('.swatch');
   
//     if (swatch) {
//       const swatchBg = getComputedStyle(swatch).getPropertyValue('--swatch--background').trim();
//       if (swatchBg) {
//         label.style.setProperty('--swatch--background', swatchBg);
//       }
//     }
//   });
// }

// // Initial run
// document.addEventListener('DOMContentLoaded', updateSwatchLabelColors);

// // Observe DOM changes (for variant updates etc.)
// const observer = new MutationObserver(mutations => {
//   for (const mutation of mutations) {
//     if (mutation.addedNodes.length || mutation.attributeName) {
//       updateSwatchLabelColors();
//       break;
//     }
//   }
// });

// // Observe entire product section or document
// observer.observe(document.body, {
//   childList: true,
//   subtree: true,
//   attributes: true,
// });

function updateSwatchLabelColors() {
  document.querySelectorAll('.swatch-input__label').forEach(label => {
    const swatch = label.querySelector('.swatch');

    if (swatch) {
      const inlineBg = swatch.style.getPropertyValue('--swatch--background');
      const computedBg = getComputedStyle(swatch).getPropertyValue('--swatch--background').trim();
      const swatchBg = inlineBg || computedBg;

      if (swatchBg) {
        label.style.setProperty('--swatch--background', swatchBg);
      }
    }
  });
 
}

// Initial load
document.addEventListener('DOMContentLoaded', updateSwatchLabelColors);

// Observe DOM mutations
const observer = new MutationObserver(() => {
  setTimeout(updateSwatchLabelColors, 50);
});

observer.observe(document.body, {
  childList: true,
  subtree: true,
});

// Trigger on Shopify events
document.addEventListener('shopify:section:load', updateSwatchLabelColors);
document.addEventListener('shopify:section:select', updateSwatchLabelColors);
document.addEventListener('quick-add:loaded', updateSwatchLabelColors); // Only works if theme emits it





